import React from 'react';
import './StudioPage.scss';

const StudioPage: React.FC = () => {
  return (
    <div className="studio-page">
      {/* Marquee Row 1 - Moving Left */}
      <div className="studio-page__marquee studio-page__marquee--left">
        <div className="studio-page__marquee-track">
          {[...Array(8)].map((_, i) => (
            <div key={i} className="studio-page__marquee-item">
              <div className="studio-page__photo studio-page__photo--portrait">
                <span className="studio-page__photo-label">LOOK {String(i % 4 + 1).padStart(2, '0')}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Marquee Row 2 - Moving Right */}
      <div className="studio-page__marquee studio-page__marquee--right">
        <div className="studio-page__marquee-track">
          {[...Array(8)].map((_, i) => (
            <div key={i} className="studio-page__marquee-item">
              <div className="studio-page__photo studio-page__photo--landscape">
                <span className="studio-page__photo-label">SS25 — {String(i % 4 + 1).padStart(2, '0')}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Marquee Row 3 - Moving Left (Faster) */}
      <div className="studio-page__marquee studio-page__marquee--left studio-page__marquee--fast">
        <div className="studio-page__marquee-track">
          {[...Array(8)].map((_, i) => (
            <div key={i} className="studio-page__marquee-item">
              <div className="studio-page__photo studio-page__photo--square">
                <span className="studio-page__photo-label">DETAIL {String(i % 4 + 1).padStart(2, '0')}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Brand Text Overlay */}
      <div className="studio-page__overlay">
        <h1 className="studio-page__title">SHTROM STUDIO</h1>
        <p className="studio-page__subtitle">PARIS — NEW YORK — TOKYO</p>
      </div>
    </div>
  );
};

export default StudioPage;
